import { Content, Page, Header } from '@backstage/core-components';
import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Chat } from './components/Chat';
import { AppStateProvider } from './state/AppProvider';

const useStyles = makeStyles(_theme => ({
  chatPaper: {
    height: 'calc(100vh - 250px)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

export const AiAssistantPage = () => {
  const classes = useStyles();

  return (
    <Page themeId="tool">
      <Header
        title="AI Assistant"
        subtitle="AI-powered chat assistant for developer support"
      />
      <Content>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.chatPaper} elevation={2}>
              <AppStateProvider>
                <Chat />
              </AppStateProvider>
            </Paper>
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};

